import { File } from 'lucide-react'
import { cn } from '~/utils'

export const FileCardDisplay = ({ allowFileUpload }: { allowFileUpload?: boolean }) => {
  return (
    <div className={cn('bpComposerFileAttachement m-2', { '!hidden': !allowFileUpload })}>
      <div className="flex">
        <File className="bpComposerFileIcon m-auto" />
      </div>
      <div className="bpComposerFileMetadata w-14 justify-center space-y-1 pr-1">
        <div className="bpComposerFileName h-2 !w-8 !min-w-12 rounded-full bg-[var(--bpGray-200)]" />
        <div className="bpComposerFileType h-2 w-6 rounded-full bg-[var(--bpGray-200)]" />
      </div>
    </div>
  )
}
